var map = {
	"./candy-thief/CandyThief-Icon.webp": 7988,
	"./candy-thief/CandyThief-MainMenu.webp": 6633,
	"./candy-thief/CandyThief1.webp": 1088,
	"./candy-thief/CandyThief2.webp": 2246,
	"./debugging/Debugging-Icon.webp": 4235,
	"./debugging/Debugging-MainMenu.webp": 6460,
	"./debugging/Debugging1.webp": 4349,
	"./debugging/Debugging2.webp": 2000,
	"./debugging/Debugging3.webp": 2815,
	"./debugging/Debugging4.webp": 413,
	"./debugging/Debugging5.webp": 969,
	"./debugging/Debugging6.webp": 2567,
	"./fade/Fade-Icon.webp": 8739,
	"./fade/Fade-MainMenu.webp": 3161,
	"./fade/Fade1.webp": 8370,
	"./fade/Fade2.webp": 2296,
	"./fade/Fade3.webp": 6715,
	"./fade/Fade4.webp": 2425,
	"./future-me/FutureMe-Icon.webp": 5868,
	"./future-me/FutureMe-MainMenu.webp": 5757,
	"./future-me/FutureMe1.webp": 5126,
	"./future-me/FutureMe2.webp": 7573,
	"./minion-mania/MinionMania-Icon.webp": 9276,
	"./minion-mania/MinionMania-MainMenu.webp": 3547,
	"./minion-mania/MinionMania1.webp": 1226,
	"./minion-mania/MinionMania2.webp": 4026,
	"./minion-mania/MinionMania3.webp": 3643,
	"./neon-signs/NeonSigns-Icon.webp": 2178,
	"./neon-signs/NeonSigns-MainMenu.webp": 8391,
	"./neon-signs/NeonSigns1.webp": 7522,
	"./neon-signs/NeonSigns10.webp": 937,
	"./neon-signs/NeonSigns11.webp": 1536,
	"./neon-signs/NeonSigns12.webp": 494,
	"./neon-signs/NeonSigns13.webp": 3529,
	"./neon-signs/NeonSigns14.webp": 6954,
	"./neon-signs/NeonSigns15.webp": 2943,
	"./neon-signs/NeonSigns16.webp": 1095,
	"./neon-signs/NeonSigns2.webp": 995,
	"./neon-signs/NeonSigns3.webp": 5250,
	"./neon-signs/NeonSigns4.webp": 1079,
	"./neon-signs/NeonSigns5.webp": 5530,
	"./neon-signs/NeonSigns6.webp": 451,
	"./neon-signs/NeonSigns7.webp": 3937,
	"./neon-signs/NeonSigns8.webp": 8788,
	"./neon-signs/NeonSigns9.webp": 364,
	"./neon-signs/NeonSignsLogo.webp": 4444,
	"./nock-fletcher/NockFletcher-Icon.webp": 1327,
	"./nock-fletcher/NockFletcher-MainMenu.webp": 2706,
	"./nock-fletcher/NockFletcher1.webp": 8040,
	"./nock-fletcher/NockFletcher2.webp": 8339,
	"./nock-fletcher/NockFletcher3.webp": 9674,
	"./nock-fletcher/NockFletcher4.webp": 8935,
	"./nock-fletcher/NockFletcher5.webp": 3312,
	"./nock-fletcher/NockFletcher6.webp": 1630,
	"./nock-fletcher/NockFletcher7.webp": 1102,
	"./nock-fletcher/NockFletcher8.webp": 8846,
	"./time-capsule/Capsule1.webp": 1472,
	"./time-capsule/Capsule2.webp": 3406,
	"./time-capsule/Capsule3.webp": 9425,
	"./time-capsule/Capsule4.webp": 2100,
	"./time-capsule/Capsule5.webp": 1549,
	"./time-capsule/TimeCapsule-Icon.webp": 6748,
	"./time-capsule/TimeCapsule-MainMenu.webp": 6798,
	"./time-management/TimeManagement-Icon.webp": 7856,
	"./time-management/TimeManagement-MainMenu.webp": 9964,
	"./time-management/TimeManagement1.webp": 9264,
	"./time-management/TimeManagement2.webp": 2366,
	"./time-management/TimeManagement3.webp": 8504,
	"./time-management/TimeManagement4.webp": 4730,
	"./time-management/TimeManagement5.webp": 4326,
	"./time-management/TimeManagement6.webp": 2792,
	"./time-management/TimeManagement7.webp": 4394,
	"./time-management/TimeManagement8.webp": 7626,
	"./time-management/TimeManagement9.webp": 9356,
	"./vaccination-destination/DownloadIconWhite.webp": 4101,
	"./vaccination-destination/VD-MainMenu.webp": 1007,
	"./vaccination-destination/VD1.webp": 5597,
	"./vaccination-destination/VD2.webp": 1831,
	"./vaccination-destination/VD3.webp": 8575,
	"./vaccination-destination/VD4.webp": 889,
	"./vaccination-destination/VD5.webp": 3142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5216;